/**
 * Test IDs for QA automation.
 */
export const testIds = {
  orgMaintenanceTasksListPendingNavigation: "org-maintenance-tasks-list-pending-navigation",
  orgMaintenanceTasksListPendingView: "org-maintenance-tasks-list-pending-view",
  orgMaintenanceTasksListCompleted: "org-maintenance-tasks-list-completed",
  orgMaintenanceTasksListCreateTask: "org-maintenance-tasks-list-create-task",
} as const;
